module.exports = __webpack_public_path__ + "img/game4.1.2cdfe08d.png";